 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import HALF_TITLE from '@/components/half_title'
 import TITLE_PAGE from '@/components/title_page'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import PREFACE from '@/components/preface'
 import PART_I_INTRODUCTION from '@/components/part_i_introduction'
 import CHAPTER_ONE_THE_EVE_OF_BATTLE from '@/components/chapter_one_the_eve_of_battle'
 import CHAPTER_TWO_BATTLES_AND_BATTLEFIELDS from '@/components/chapter_two_battles_and_battlefields'
 import PART_II_THE_ELEMENTS_OF_COMBAT from '@/components/part_ii_the_elements_of_combat'
 import CHAPTER_THREE_ARTILLERY from '@/components/chapter_three_artillery'
 import CHAPTER_FOUR_LIGHT_INFANTRY from '@/components/chapter_four_light_infantry'
 import CHAPTER_FIVE_INFANTRY_COMBAT from '@/components/chapter_five_infantry_combat'
 import CHAPTER_SIX_CAVALRY_COMBAT from '@/components/chapter_six_cavalry_combat'
 import PART_III_COMMAND_AND_CONTROL from '@/components/part_iii_command_and_control'
 import CHAPTER_SEVEN_THE_ROLE_OF_THE_GENERAL from '@/components/chapter_seven_the_role_of_the_general'
 import CHAPTER_EIGHT_SUBORDINATE_COMMANDERS_STAFF_OFFICERS_AND_ADCS from '@/components/chapter_eight_subordinate_commanders_staff_officers_and_adcs'
 import CHAPTER_NINE_REGIMENTAL_OFFICERS from '@/components/chapter_nine_regimental_officers'
 import CHAPTER_TEN_MORALE_AND_COHESION from '@/components/chapter_ten_morale_and_cohesion'
 import CHAPTER_ELEVEN_ATTITUDES_AND_FEELINGS from '@/components/chapter_eleven_attitudes_and_feelings'
 import PART_IV_THE_END_OF_THE_DAY from '@/components/part_iv_the_end_of_the_day'
 import CHAPTER_TWELVE_VICTORY_OR_DEFEAT from '@/components/chapter_twelve_victory_or_defeat'
 import CHAPTER_THIRTEEN_AFTER_THE_FIGHTING from '@/components/chapter_thirteen_after_the_fighting'
 import EPILOGUE from '@/components/epilogue'
 import NOTES from '@/components/notes'
 import BIBLIOGRAPHICAL_ESSAY from '@/components/bibliographical_essay'
 import BIBLIOGRAPHY from '@/components/bibliography'
 import INDEX from '@/components/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/half_title",
 			"name" : "half_title",
 			"component" : HALF_TITLE
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/preface",
 			"name" : "preface",
 			"component" : PREFACE
 		},
 		{
 			"path" : "/part_i_introduction",
 			"name" : "part_i_introduction",
 			"component" : PART_I_INTRODUCTION
 		},
 		{
 			"path" : "/chapter_one_the_eve_of_battle",
 			"name" : "chapter_one_the_eve_of_battle",
 			"component" : CHAPTER_ONE_THE_EVE_OF_BATTLE
 		},
 		{
 			"path" : "/chapter_two_battles_and_battlefields",
 			"name" : "chapter_two_battles_and_battlefields",
 			"component" : CHAPTER_TWO_BATTLES_AND_BATTLEFIELDS
 		},
 		{
 			"path" : "/part_ii_the_elements_of_combat",
 			"name" : "part_ii_the_elements_of_combat",
 			"component" : PART_II_THE_ELEMENTS_OF_COMBAT
 		},
 		{
 			"path" : "/chapter_three_artillery",
 			"name" : "chapter_three_artillery",
 			"component" : CHAPTER_THREE_ARTILLERY
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js